{
  "slug": "what-is-the-average-iq",
  "title": "IQの平均は？100の意味と分布",
  "description": "IQの平均が通常100に設定される理由、85〜115の範囲、パーセンタイル、比較時の注意点を説明します。",
  "summary": "多くの現代的なIQ尺度では平均は100です。基準集団のおよそ3分の2が85から115の範囲に入ります。",
  "category": "IQの基礎",
  "sections": [
    {
      "heading": "なぜ平均が100なのか",
      "paragraphs": [
        "素点は基準集団と比較して標準得点に変換されます。100問正解したという意味ではありません。",
        "人口や教育環境の変化に合わせて検査は再標準化されるため、検査名、版、年齢基準を確認する必要があります。"
      ]
    },
    {
      "heading": "85から115の一般的な範囲",
      "paragraphs": [
        "標準偏差15のモデルでは、正規分布のおよそ68％が85から115の間にあります。100はおよそ50パーセンタイルです。",
        "パーセンタイルは正答率ではなく、同年齢の基準集団内での相対的位置です。"
      ]
    },
    {
      "heading": "比較するときの注意",
      "paragraphs": [
        "言語、教育、健康、アクセス、受検条件が影響します。特に国や集団の比較では、標本と方法を確認する必要があります。",
        "個人については、総合得点を完全に正確な数字として扱うより、信頼区間と領域別プロフィールを見る方が有用です。"
      ]
    }
  ],
  "faqs": [
    {
      "question": "IQ100は良い得点ですか？",
      "answer": "基準集団の中央付近で、測定された能力について典型的な成績を表します。"
    },
    {
      "question": "IQ100より高い人は半分ですか？",
      "answer": "平均100に調整された分布ではおおよそ半分ですが、実際の分布は完全な左右対称ではありません。"
    }
  ],
  "related": ["what-is-iq", "iq-score-ranges-explained", "free-online-iq-test-guide"],
  "sources": [
    {
      "label": "APA Dictionary of Psychology — IQ",
      "url": "https://dictionary.apa.org/iq"
    }
  ]
}
